<template>
<div class="logobox" :class="[name]">
  <img :src="image" />
</div>
</template>

<script>
export default {
  props:["name","image"]
}
</script>

<style lang="scss" scoped>

.logobox{
  height: 100px;
  width: 260px;
  display: block;
  text-align: center;
  margin: 0 auto 50px;
}

.logobox.bolsa-dges{
  background-color: #11416b;
  -webkit-box-shadow: 3px 2px 8px 0px rgba(77,77,77,0.25);
  box-shadow: 3px 2px 8px 0px rgba(77,77,77,0.25);
}
.logobox.bolsa-santander{
  background-color: #ec1e24;
  -webkit-box-shadow: 3px 2px 8px 0px rgba(77,77,77,0.25);
  box-shadow: 3px 2px 8px 0px rgba(77,77,77,0.25);
}
.logobox.bolsa-afa{
  background-color: #F9BC3B;
  -webkit-box-shadow: 3px 2px 8px 0px rgba(77,77,77,0.25);
  box-shadow: 3px 2px 8px 0px rgba(77,77,77,0.25);
}
.logobox.bolsa-blandy{
  background-color: #e1e3e5;
  -webkit-box-shadow: 3px 2px 8px 0px rgba(77,77,77,0.25);
  box-shadow: 3px 2px 8px 0px rgba(77,77,77,0.25);
}
.logobox.fundo-de-apoio-de-emergencia{
  background-color: #a3d9f0;
  -webkit-box-shadow: 3px 2px 8px 0px rgba(77,77,77,0.25);
  box-shadow: 3px 2px 8px 0px rgba(77,77,77,0.25);
}

@media (max-width: 767px) {
  .logobox {
    height: 65px;
    margin: 0 auto 35px;
  }

  .logobox img{
    height: 100px;
  }
}
</style>